import Call from '../Call';

const AdkFeeds = {
    get() {
        return Call(`adkFeeds`);
    },

    getIds() {
        return Call(`adkFeeds/ids`);
    },

    save(feed) {
        return Call('adkFeeds','POST', feed);
    },

    update(id, feed) {
        return Call(`adkFeeds/${id}`,'PUT', feed);
    },

    remove(id) {
        return Call(`adkFeeds/${id}`,'DELETE');
    }
};

export default AdkFeeds;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkFeeds.js